module.exports = __webpack_public_path__ + "static/img/DSC08062.901254c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/items/nyomtatott-konyhahatfal/fekete/DSC08062.jpg
// module id = 578
// module chunks = 0